import React, { useId } from 'react';
import { RATE_SEPARATOR_DESIGN_OPTIONS } from '../constants/bookingConst';
import '../css/RateSeparatorDisplaySettings.css';

/**
 * Whether the time slot grids (guest and admin) show a separator where each
 * hourly rate starts, and which design it uses — one row above the Hourly
 * rates list in Config -> Sports & Courts. Every rate below it previews its
 * own separator in the chosen design.
 *
 * Both settings are club-wide, so the row repeats (in sync) under each sport.
 * Edits only the form — guests see the change once the config is saved and
 * redeployed, and the save writes the audit entry.
 *
 * @param {object} props
 * @param {boolean} props.show - formData.showRateSeparators (resolved, never undefined)
 * @param {string} props.design - the resolved design value
 * @param {(show: boolean) => void} props.onShowChange
 * @param {(design: string) => void} props.onDesignChange
 * @returns {JSX.Element}
 */
function RateSeparatorDisplaySettings({ show, design, onShowChange, onDesignChange }) {
  // Unique per instance: the row repeats under every sport.
  const selectId = useId();

  return (
    <div className="rsd-row">
      <label className="rsd-toggle">
        <input type="checkbox" checked={show} onChange={(e) => onShowChange(e.target.checked)} />
        <span>Show rate separators</span>
      </label>
      <span className={`rsd-design${show ? '' : ' rsd-disabled'}`}>
        <label className="rsd-label" htmlFor={selectId}>Design</label>
        <select
          id={selectId}
          className="rsd-select"
          value={design}
          onChange={(e) => onDesignChange(e.target.value)}
          disabled={!show}
        >
          {RATE_SEPARATOR_DESIGN_OPTIONS.map(option => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
      </span>
      <span className="rsd-note">Applies to every sport.</span>
    </div>
  );
}

export default RateSeparatorDisplaySettings;
